import React, {Component} from "react";
import {BubbleLoader} from "react-css-loaders";
import {ST} from "../global/SystemText";
import Breadcrumbs from "./Breadcrumbs";
import ProductTile from "../components/ProductTile";
import {Button, Col, FormControl, FormGroup, Row} from "react-bootstrap";
import axios from "axios";
import {Session} from "../global/PortalTools";
import * as PT from "../global/PortalTools";

export default class MyProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: true,
            data: [],
            query:"",
        };

    }

    // Trigger search when user presses Enter in the local search input
    handleEnterKey = (e) => {
        if (e && (e.key === 'Enter' || e.keyCode === 13)) {
            if (typeof e.preventDefault === 'function') e.preventDefault();
            this.getSearchResults();
        }
    }

    componentDidMount() {
        // Listen for global search submissions triggered from the header search bar
        this._onGlobalSearchSubmit = (e) => {
            try {
                const incomingQuery = e && e.detail && e.detail.query ? String(e.detail.query).trim() : '';
                if (incomingQuery.length > 0) {
                    this.setState({query: incomingQuery}, () => this.getSearchResults());
                }
            } catch (err) {
                // fail silently
            }
        };
        window.addEventListener('globalSearchSubmit', this._onGlobalSearchSubmit);

        this.setState({query:(Session.getItem("searchQuery")===undefined || Session.getItem("searchQuery")== null )?"":Session.getItem("searchQuery")}, () => {
            this.getSearchResults();
        });
    }

    componentWillUnmount() {
        // Clean up the listener when leaving SearchPage
        if (this._onGlobalSearchSubmit) {
            window.removeEventListener('globalSearchSubmit', this._onGlobalSearchSubmit);
        }
    }

    getSearchResults() {
        if(this.state.query.trim().length<3){
            return;
        }
        this.setState({loaded:false});
        Session.setItem("searchQuery",this.state.query);
        axios.get(Session.getItem("endpoint") + 'PortalServlet', {
            params: {
                idMandant: Session.idMandant,
                idCompany:Session.getItem("idCompany"),
                idContact:Session.getItem("idContact"),
                idLanguage:Session.getItem("idLanguage"),
                idCurrency:Session.getItem("idCurrency"),
                priceLevel:Session.getItem("priceLevel"),
                query: this.state.query,
                action: "GET_SEARCH_RESULTS_EXTENDED"
            }
        })
        .then((response) => {
            this.setState({
                data: response.data.options,
                countProducts:response.data.countProducts,
                loaded: true
            });
            console.log(response.data);
        })
        .catch((error) => {
            PT.handleError(error, this.props.history);
        });
    }

    setQueryValue(key, value) {
        let {query} = this.state;
        query = value;
        this.setState({query});
    }

    render() {
        let tiles = this.state.data;
        return (
            <div className="panel border-top-xlg" style={{borderColor: window.portalSettings.portal_pcolor}}>
                <Breadcrumbs active={ST.get("search", "global")}/>
                <div className="panel-heading no-padding-bottom">
                    <h3 className="panel-title">{ST.get("search", "global")}</h3>
                </div>
                <div className="panel-body">
                    <div className="product-toolbox">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="input-group">
                                    <Row>
                                        <Col md={9}>
                                        <FormGroup controlId={"searchbar"}>
                                            <FormControl
                                                className={"form-control-bordered"}
                                                type={"text"}
                                                onChange={(event) => this.setQueryValue('number', event.target.value)}
                                                onKeyDown={this.handleEnterKey}
                                                value={this.state.query}/>
                                        </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <Button onClick={this.getSearchResults.bind(this)}>{ST.get("search", "global")}</Button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.loaded ? (
                        <Row>
                            {tiles.map((element, index) => {
                                if(element.type==="product"){
                                    return (<ProductTile data={element.product_data} key={"productTile" + index}/>);
                                }
                            })}
                        </Row>
                    ) : (
                        <BubbleLoader color={window.portalSettings.portal_pcolor}/>
                    ) }

                </div>
            </div>
        );
    }
}